import './App.css';
import EventList from "./Pages/EventList.jsx";

function App() {

    return <div style={{marginLeft: "20px"}}>
        <EventList />
    </div>;
}

export default App;
